// Las cadenas del silo para la pestaña de referidos; misma lectura y caché que el selector de cadena.
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listRetailers } from '@/api/services/retail-org/retail-org.client';
import { COLLECTIONS_KEY } from '@/domains/credit/collections/api/useCollections';
import type { RetailerOption } from '@/shared/domain/retailerOption';

export function useReferralRetailers(enabled: boolean) {
    const query = useQuery({
        queryKey: [COLLECTIONS_KEY, 'retailers'],
        queryFn: listRetailers,
        staleTime: 300_000,
        enabled,
    });
    const data = useMemo<RetailerOption[] | undefined>(
        () =>
            enabled
                ? (query.data ?? []).map((retailer) => ({
                      retailerId: retailer.retailerId,
                      name: retailer.name,
                  }))
                : undefined,
        [enabled, query.data],
    );
    return {
        data,
        isLoading: enabled && query.isLoading,
        error: enabled ? query.error : null,
        refetch: () => query.refetch(),
    };
}
